// extracted by mini-css-extract-plugin
export default {"round_checkbox":"style_round_checkbox__uGtRC","checked":"style_checked__RxvHu","inner_circle":"style_inner_circle__l9XIU"};